import React from 'react';
import ShortId from './ShortId';

// One member as a card (photo, name, age, gender, location) — the layout used
// by Email → Interconnecting and the Community Analytics tab. The page that
// uses it supplies what changes between them:
//   select     — e.g. the checkbox, shown before the photo
//   meta       — extra bits after the location (distance, badges…)
//   note       — a line under the location (e.g. "Already rejected…")
//   children   — the row of links (Full info, Bot chat, Sort nearest…)
const MemberCard = ({ member: m, className = '', onClick, select, meta, note, children }) => (
  <div className={`as-signup-card${className ? ` ${className}` : ''}`} onClick={onClick}>
    {select && <div className="as-signup-select">{select}</div>}
    {m.photo ? <img src={m.photo} alt="" className="as-signup-img" /> : <div className="as-signup-img-placeholder">?</div>}
    <div className="as-signup-details">
      <div className="as-signup-headline">
        <strong>{m.firstName || '(no name)'}</strong>{!m.waitlist && !m.search && <ShortId userId={m.userId} />}
        {m.age != null && <span className="as-signup-age">{m.age}</span>}
        {m.gender && <span className="as-card-meta"> · {m.gender}</span>}
      </div>
      <div className="as-card-meta">
        {m.localArea || 'Location not set'}
        {meta}
      </div>
      {note}
      {children && <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>{children}</div>}
    </div>
  </div>
);

export default MemberCard;
